export const IMAGE_UTMS = '?utm_source=ssendpulse&utm_medium=referral';
